import { updateField } from 'vuex-map-fields'

import { FETCH_ACCOUNT_LOADING, FETCH_ACCOUNT_DONE, FETCH_ACCOUNT_ERROR, UPDATE_ACCOUNT_LOADING, UPDATE_ACCOUNT_DONE, UPDATE_ACCOUNT_ERROR, CHANGE_PASSWORD_LOADING, CHANGE_PASSWORD_DONE, CHANGE_PASSWORD_ERROR, UPLOAD_PHOTO_LOADING, UPLOAD_PHOTO_DONE, UPLOAD_PHOTO_ERROR, EDIT_ACCOUNT_DONE, EDIT_ACCOUNT_LOADING, EDIT_ACCOUNT_ERROR } from './actions'

export default {
  updateField,

  [FETCH_ACCOUNT_LOADING] (state) {
    state.isLoading = true
  },

  [FETCH_ACCOUNT_DONE] (state, account) {
    state.account = account
    state.isLoading = false
  },

  [FETCH_ACCOUNT_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [UPDATE_ACCOUNT_LOADING] (state) {
    state.isLoadingUpdateAccount = true
    state.errorUpdateAccount = false
  },

  [UPDATE_ACCOUNT_DONE] (state, updateAccount) {
    state.updateAccount = updateAccount
    state.isLoadingUpdateAccount = false
  },

  [UPDATE_ACCOUNT_ERROR] (state, error) {
    state.errorUpdateAccount = error
    state.isLoadingUpdateAccount = false
  },

  [CHANGE_PASSWORD_LOADING] (state) {
    state.isLoadingChangePassword = true
  },

  [CHANGE_PASSWORD_DONE] (state, item) {
    state.changePassword = item
    state.isLoadingChangePassword = false
    state.errorChangePassword = null
  },

  [CHANGE_PASSWORD_ERROR] (state, error) {
    state.errorChangePassword = error
    state.isLoadingChangePassword = false
  },

  [UPLOAD_PHOTO_LOADING] (state) {
    state.isLoading = true
  },

  [UPLOAD_PHOTO_DONE] (state, account) {
    state.account = account
    state.isLoading = false
  },

  [UPLOAD_PHOTO_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [EDIT_ACCOUNT_LOADING] (state) {
    state.isLoadingEditAccount = true
  },

  [EDIT_ACCOUNT_DONE] (state, account) {
    state.EditAccount = account
    state.isLoadingEditAccount = false
  },

  [EDIT_ACCOUNT_ERROR] (state, error) {
    state.errorEditAccount = error
    state.isLoadingEditAccount = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings/account/mutations.js